import Settings from '../../../modules/superAdmin/Settings';
import NotificationList from '../../../modules/superAdmin/Settings/NotificationList';
import PasswordSecurity from '../../../modules/superAdmin/Settings/PasswordSecurity';
import PrivacyPolicy from '../../../modules/superAdmin/Settings/PrivacyPolicy';
import UserInfo from '../../../modules/superAdmin/Settings/UserInfo';
import ShiftLogBook from '../../../modules/superAdmin/dashboard';
import ShiftInfoPage from '../../../modules/superAdmin/dashboard/ShiftInfo';

const routes = [
  {
    path: '/ShiftLogbook',
    element: <ShiftLogBook />,
  },
  {
    path: '/ShiftLogbook/:id',
    element: <ShiftInfoPage />,
  },
  {
    path: '/notifications',
    element: <NotificationList />,
  },
  {
    path: '/settings',
    element: <Settings />,
    children: [
      { path: 'user-info', element: <UserInfo /> },
      { path: 'password', element: <PasswordSecurity /> },
      { path: 'notifications', element: <NotificationList /> },
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
    ],
  },
];

export default routes;
